document.getElementById("downloadProductsData").addEventListener("click", function () {

  let clickedElement = this;  
  let totalProductsCount = Number(this.getAttribute("data-totalCount"));
  let fetchRequestsCount = Math.ceil(totalProductsCount / 48);
  let csvRows = [];
  csvRows.push("Product Name,Variant Title,SKU,Discontinued For Production,Style Collection Name,Manufacturer Country,UPC,Item Category,Retail URL,Dimensions,Product Weight,Shipping Method,Shipping Dimensions,Shipping Width,Shipping Depth,Shipping Height,Shipping Weight,Flat Rate Shipping,Assembly Required,Product Color,Item Size,Product Materials,Weight Capacity,Seat Width,Seat Depth,Seat Height,Arm Height,Leg Height,Seat Support,Seat Fill Material,Leg Color,SideRail Height,Slat Height,Distance Between Slats,Swatch Code,Soft Close,Drawer Dimensions,Cabinet Dimensions,Adjustable Shelves,Cord Length,Shade Dimensions,Base Dimensions,Switch Type,Power Source,Number of Bulbs Required,Bulb Type,Bulb Shape,Max Wattage,LED Compatible,Description,Features,Item Image 1,Item Image 2,Item Image 3,Item Image 4,Item Image 5,Item Image 6,Item Image 7,Item Image 8,Item Image 9,Item Image 10,Assembly Instructions");  
  
  this.textContent = "Started";
  this.disabled = true;


  // Warning before page unload
  const beforeUnloadHandler = (e) => {
    e.preventDefault();
    e.returnValue = 'Download is in progress. Are you sure you want to leave?';
    return 'Download is in progress. Are you sure you want to leave?';
  };
  
  // Add the warning
  window.addEventListener('beforeunload', beforeUnloadHandler);

  function csvEscape(value) {
    if (value == null) return '""';
    const v = value.toString().replace(/"/g, '""');
    return `"${v.replace(/\r?\n/g, ' ')}"`; // keep it one line
  }



  async function fetchDataInSequence() {
  
    try {
      // Loop through all pages and collect data
      for(let i = 1; i <= fetchRequestsCount; i++) {
        console.log(`Fetching page ${i} of ${fetchRequestsCount}`);  
        let response = await fetch(`https://trade.tovfurniture.com/collections/all-products-data?page=${i}`);
        if (!response.ok) throw new Error(`HTTP ${response.status} on page ${i}`);
        let data = await response.text();
        let progress = Math.round((i/fetchRequestsCount) * 100);
        if(progress >= 100) {
          clickedElement.textContent = "Completed";
        }
        else {
          clickedElement.textContent = `In Progress (${progress}%)`;
        }        
        dataProcessing(data); // This will append to csvContent
        
      }
      
      // After all data is collected, create and download the CSV
      // Create CSV using Blob (no size limit)
      const csvContent = csvRows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", "all_products_data.csv");
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL object
      URL.revokeObjectURL(url);
      
    } 
    catch (error) {
      console.log("General error:", error);
      clickedElement.textContent = "Failed";

    } 
    finally {
      // Reset button text only after all operations complete
      // document.getElementById("downloadCSV").textContent = "Download";
      setTimeout(() => {        
        clickedElement.textContent = "Download";
        clickedElement.disabled = false; 
      }, 2000);
    }     
    
  }

  function dataProcessing(data) {    
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const gridItem = Array.from(doc.body.querySelectorAll("#product-grid .grid__item"));    
    console.log("Grid Items in this page:", gridItem.length);
    gridItem.forEach(function (item) {
      let productTitle = item.querySelector(".catalog-product-title").innerHTML;
      const variantDataWrapper = item.querySelectorAll(".catalog-variant-data-wrapper");
      variantDataWrapper.forEach(function (variant) {
        let variantTitle = variant.querySelector(".catalog-variant-title").innerHTML;
        let variantSku = variant.querySelector(".catalog-variant-sku").innerHTML;
        let variantDfp = variant.querySelector(".catalog-variant-dfp").innerHTML;
        let variantScn = variant.querySelector(".catalog-variant-scn").innerHTML;
        let variantMc = variant.querySelector(".catalog-variant-mc").innerHTML;
        let variantUpc = variant.querySelector(".catalog-variant-upc").innerHTML;
        let variantIc = variant.querySelector(".catalog-variant-ic").innerHTML;
        let variantURL = variant.querySelector(".catalog-variant-url").innerHTML;
        let variantPd = variant.querySelector(".catalog-variant-pd").innerHTML;
        let variantPw = variant.querySelector(".catalog-variant-pw").innerHTML;
        let variantSm = variant.querySelector(".catalog-variant-sm").innerHTML;
        let variantShippingDimensions = variant.querySelector(".catalog-variant-shipping-dimensions").innerHTML;
        let variantShippingWidth = variant.querySelector(".catalog-variant-shipping-width").innerHTML;
        let variantShippingDepth = variant.querySelector(".catalog-variant-shipping-depth").innerHTML;
        let variantShippingHeight = variant.querySelector(".catalog-variant-shipping-height").innerHTML;
        let variantShippingWeight = variant.querySelector(".catalog-variant-shipping-weight").innerHTML;
        let variantFrs = variant.querySelector(".catalog-variant-frs").innerHTML;
        let variantAr = variant.querySelector(".catalog-variant-ar").innerHTML;
        let variantProductColor = variant.querySelector(".catalog-variant-product-color").innerHTML;
        let variantItemSize = variant.querySelector(".catalog-variant-item-size").innerHTML;
        let variantPm = variant.querySelector(".catalog-variant-pm").innerHTML;
        let variantWc = variant.querySelector(".catalog-variant-wc").innerHTML;
        let variantSw = variant.querySelector(".catalog-variant-sw").innerHTML;
        let variantSd = variant.querySelector(".catalog-variant-sd").innerHTML;
        let variantSh = variant.querySelector(".catalog-variant-sh").innerHTML;
        let variantAh = variant.querySelector(".catalog-variant-ah").innerHTML;
        let variantLh = variant.querySelector(".catalog-variant-lh").innerHTML;
        let variantSs = variant.querySelector(".catalog-variant-ss").innerHTML;
        let variantSfm = variant.querySelector(".catalog-variant-sfm").innerHTML;
        let variantLc = variant.querySelector(".catalog-variant-lc").innerHTML;
        let variantSih = variant.querySelector(".catalog-variant-sih").innerHTML;
        let variantSlh = variant.querySelector(".catalog-variant-slh").innerHTML;
        let variantDbs = variant.querySelector(".catalog-variant-dbs").innerHTML;
        let variantSc = variant.querySelector(".catalog-variant-sc").innerHTML;
        let variantSoftClose = variant.querySelector(".catalog-variant-soft-close").innerHTML;
        let variantDd = variant.querySelector(".catalog-variant-dd").innerHTML;
        let variantCd = variant.querySelector(".catalog-variant-cd").innerHTML;
        let variantAs = variant.querySelector(".catalog-variant-as").innerHTML;
        let variantCl = variant.querySelector(".catalog-variant-cl").innerHTML;
        let variantShadeDimensions = variant.querySelector(".catalog-variant-shade-dimensions").innerHTML;
        let variantBaseDimensions = variant.querySelector(".catalog-variant-base-dimensions").innerHTML;
        let variantSwitchType = variant.querySelector(".catalog-variant-switch-type").innerHTML;
        let variantPowerSource = variant.querySelector(".catalog-variant-power-source").innerHTML;
        let variantBulbsRequired = variant.querySelector(".catalog-variant-bulbs-required").innerHTML;
        let variantBulbType = variant.querySelector(".catalog-variant-bulb-type").innerHTML;
        let variantBulbShape = variant.querySelector(".catalog-variant-bulb-shape").innerHTML;
        let variantMaxWattage = variant.querySelector(".catalog-variant-max-wattage").innerHTML;
        let variantLedCompatible = variant.querySelector(".catalog-variant-led-compatible").innerHTML;
        let variantDescription = variant.querySelector(".catalog-variant-description").textContent;
        let variantFeatures = variant.querySelector(".catalog-variant-features").innerText;
        let variantImage1 = variant.querySelector(".catalog-variant-item-image1").innerHTML;
        let variantImage2 = variant.querySelector(".catalog-variant-item-image2").innerHTML;
        let variantImage3 = variant.querySelector(".catalog-variant-item-image3").innerHTML;
        let variantImage4 = variant.querySelector(".catalog-variant-item-image4").innerHTML;
        let variantImage5 = variant.querySelector(".catalog-variant-item-image5").innerHTML;
        let variantImage6 = variant.querySelector(".catalog-variant-item-image6").innerHTML;
        let variantImage7 = variant.querySelector(".catalog-variant-item-image7").innerHTML;
        let variantImage8 = variant.querySelector(".catalog-variant-item-image8").innerHTML;
        let variantImage9 = variant.querySelector(".catalog-variant-item-image9").innerHTML;
        let variantImage10 = variant.querySelector(".catalog-variant-item-image10").innerHTML;
        let variantAssemblyInstructions = variant.querySelector(".catalog-variant-assembly-instructions").textContent.trim();
        const row = [productTitle, variantTitle, variantSku, variantDfp, variantScn, variantMc,
          variantUpc, variantIc, variantURL, variantPd, variantPw, variantSm, variantShippingDimensions, variantShippingWidth, variantShippingDepth, variantShippingHeight, 
          variantShippingWeight, variantFrs, variantAr, variantProductColor, variantItemSize, variantPm, variantWc, variantSw, variantSd, variantSh, variantAh,
          variantLh, variantSs, variantSfm, variantLc, variantSih, variantSlh, variantDbs,
          variantSc, variantSoftClose, variantDd, variantCd, variantAs, variantCl,
          variantShadeDimensions, variantBaseDimensions, variantSwitchType, variantPowerSource,
          variantBulbsRequired, variantBulbType, variantBulbShape, variantMaxWattage,
          variantLedCompatible, variantDescription, variantFeatures, variantImage1, variantImage2, variantImage3, variantImage4, variantImage5,
          variantImage6, variantImage7, variantImage8, variantImage9, variantImage10, variantAssemblyInstructions
        ].map(csvEscape).join(',');
        csvRows.push(row);     
      });
    });
  }
  fetchDataInSequence();
});